var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html-block field CompositeField composite form-group--no-label",attrs:{"id":("EditableLiteralField_" + _vm.uuid)}},[_c('div',{staticClass:"middleColumn",domProps:{"innerHTML":_vm._s(_vm.buffer)}})])}
var staticRenderFns = []

export { render, staticRenderFns }